const headers = {
    BUY: "خرید",
    VIDEOS:"ویدئوهای آموزشی"
}

export default headers